import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceManagerService } from '../service-manager.service';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss']
})
export class LanguagesComponent implements OnInit {
  languageList: any[] = [];

  constructor(
    private serviceManager: ServiceManagerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadLanguages();
  }

  loadLanguages(): void {
    this.serviceManager.CallBackendServiceAPI('list-languages', {}).subscribe((data: any) => {
      this.languageList = data.languages || [];
    });
  }

  viewLanguage(lang: any): void {
    this.router.navigate(['/language-detail', lang.id]);
  }

  addLanguage(): void {
    this.router.navigate(['/language-detail', 'new']);
  }
}
